<div class="relative w-full z-[10] tracking-tight" [ngClass]="fontFamily ? [fontFamily] : []" [class.dateBadgeStyles]="showDateBadge" [class.has-date-badge]="showDateBadge && value">
    <input 
        #dateInput 
        type="text" 
        [placeholder]="placeholder" 
        [disabled]="isDisabled" 
        [ngClass]="[
          baseClasses, 
          cssClass,
          isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : 'bg-white cursor-pointer opacity-100'
        ]" 
    />

    <span *ngIf="showDateBadge && value" class="date-badge">
        <span class="date-badge-label">{{ dateBadgeLabel }}</span>
        <button type="button" class="date-badge-remove" aria-label="Clear date" [disabled]="isDisabled" (click)="clearDateBadge($event)">
            <img  [src]="commonService.Images.CROSS_ICON_FOR_FILTERS" class="w-2 h-2 mx-1" alt="Clear date" />
        </button>
    </span>

    <!-- Icon Container -->
    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400"
        [class.opacity-50]="isDisabled">

        <!-- If mode is 'time', show the clock icon -->
        @if (mode === 'time') {
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
        } @else if (mode === 'datetime') {
            <img [src]="commonService.Images.DATE_TIME_PICKER" class="w-5 h-5" alt="datetimeIcon" />
        } @else {
            <!-- Covers 'date', 'range', and any fallback modes -->
            <img [src]="commonService.Images.NEW_ICON_FOR_DATE" class="w-5 h-5" alt="dateIcon" />
        }

    </div>
</div>


<!--1. Date range -->
 
<!-- <app-date-time-picker 
  formControlName="scheduledAt" 
  mode="range" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select a date range"
  (dateSelected)="onDateRangeSelected($event)">
</app-date-time-picker> -->

<!-- 2. Date Picker (Single Date) -->
 
 <!-- <app-date-time-picker 
  formControlName="scheduledDate" 
  mode="date" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select a date"
  (dateSelected)="onDateSelected($event)">
</app-date-time-picker> -->

<!-- 3. Date & Time Picker -->

 <!-- <app-date-time-picker 
  formControlName="scheduledDateTime" 
  mode="datetime" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [minDate]="minDate" 
  [isDisabled]="isDisabled"
  placeholder="Select date and time"
  (dateSelected)="onDateTimeSelected($event)">
</app-date-time-picker> -->

<!-- 3. Time Picker (Time Only) -->

<!-- <app-date-time-picker 
  formControlName="scheduledTime" 
  mode="time" 
  [cssClass]="'py-4 px-4 mt-2 text-base font-semibold text-primary_Text_Color'"
  [isDisabled]="isDisabled"
  placeholder="Select a time"
  (dateSelected)="onTimeSelected($event)">
</app-date-time-picker> -->



<!-- Disable fields: 
 Programmtically cuz using reactive forms,For refrence you can add in html.
this.addScheduleDriveForm.get('scheduledAt').disable(); 
-->
